'use strict';

import "angular-ui-bootstrap";

import {EwSiteApp} from '../../app/ewsiteapp';

EwSiteApp.requires.push('ui.bootstrap');

EwSiteApp.controller('EventReviewsCtrl', ["$scope", "$http", "$sce", "$uibModal", "$log", "$rootScope", function($scope, $http, $sce, $uibModal, $log, $rootScope){
	$scope.reviews = reviewsData.reviews;
	$scope.event = reviewsData.event;
	$scope.showAll    = false;

	$scope.openReview = function(){
		$scope.reviewEditor();
	};
	$scope.reviewEditor = function(){
		var template = 'event/review_editor.html';
		var entry = $scope.event;
		var modalInstance = $uibModal.open({
			templateUrl: template,
			controller: 'reviewPreviewCtrl',
			size: 'lg',
			resolve: {
				entry: function(){
					return entry;
				},
			}
		});
		modalInstance.result.then(function (result) {
//			console.log(result);
		}, function () {});
	};

	$scope.toggleReviews = function($event){
		$event.preventDefault();
		$scope.showAll = !$scope.showAll;
	};

	$scope.explicitlyTrustedHtml = function(text) {
               return $sce.trustAsHtml(text);
	};
	
}]);

EwSiteApp.controller('reviewPreviewCtrl', ["$scope", "$uibModalInstance", "$http", "$sce", "entry", function($scope, $uibModalInstance, $http, $sce, entry) {
		$scope.entry = angular.copy(entry);
		$scope.commentUrl = reviewsData.commentUrl;
		$scope.message = '';
		$scope.show_message = false;
		$scope.error = '';
		$scope.show_error = false;

		$scope.saveComment = function () {
			if ($scope.commentUrl !== '') {
				$http({
					method: 'POST',
					url: $scope.commentUrl,
					data: {
						title: $scope.entry.title,
						email: $scope.entry.email,
						comment: $scope.entry.comment,
					},
					xsrfCookieName: secure_xsrf_name,
					xsrfHeaderName: 'X-' + secure_xsrf_name
				}).then(function (response) {
					if (response.data.success) {
						console.warn(response.data);
						$scope.message = response.data.message;
						$scope.show_message = true;
						$scope.entry = {};


						$uibModalInstance.close();
					} else {
						$scope.error = response.data.message;
						$scope.show_error = true;
					}
				});
			}
		};

		$scope.cancel = function () {
			$uibModalInstance.dismiss();
		};

		$scope.explicitlyTrustedHtml = function (text) {
			return $sce.trustAsHtml(text);
		};
	}]);